import api from './index';

const BASE = '/performedCapacityReport';

export const getPerformedCapacityReport = async ({
    location,
    dateFrom,
    dateTo,
    plausibilityCheck,
}: {
    location: number;
    dateFrom: string;
    dateTo: string;
    plausibilityCheck: string;
}) => {
    return api
        .get(`${BASE}/report`, { params: { location, dateFrom, dateTo, plausibilityCheck } })
        .then((res) => res.data);
};

export const createPerformedCapacityReport = async (data: unknown, userId: number, locationId: number) => {
    return api.post(`${BASE}/create`, { data, userId, locationId }).then((res) => res.data);
};

export const createOnePerformedCapacityReport = async (data: unknown) => {
    return api.post(`${BASE}/one`, { data }).then((res) => res.data);
};

export const getPerformedCapacityReportAnalysis = async ({
    location,
    worktype,
    channel,
    task,
    capacityType,
    planDate,
    planComparisonDate,
    firstMonthColumnDate,
}: {
    location: number;
    worktype: number;
    channel: number;
    task: number;
    capacityType: number;
    planDate: string;
    planComparisonDate: string;
    firstMonthColumnDate: string;
}) => {
    return api
        .get(`${BASE}/performedCapacityReportAnalysis`, {
            params: {
                location,
                planDate,
                planComparisonDate,
                firstMonthColumnDate,
                worktype,
                channel,
                task,
                capacityType,
            },
        })
        .then((res) => res.data);
};

export const getPerformedCapacityReportUploadedDatesInMonth = async ({
    location,
    date,
}: {
    location: number;
    date: string;
}) => {
    return api.get(`${BASE}/uploadedDatesInMonth`, { params: { location, date } }).then((res) => res.data);
};

export const checkPerformedCapacityReportPlausibility = async ({
    data,
    locationId,
}: {
    data: unknown;
    locationId: number;
}) => {
    return api.post(`${BASE}/checkPlausibility`, { data, locationId }).then((res) => res.data);
};

export const getLastPerformedCapacityReportUploadDate = async (location: number): Promise<string> => {
    return api.get(`${BASE}/lastUploadDate`, { params: { location } }).then((res) => res.data);
};
